import { Link } from '../Link';
import { Text } from '@qcx/ui';

export interface BreadcrumbLinkProps {
  isCurrentPage?: boolean;
  children: React.ReactNode;
  href: string;
}

export const BreadcrumbLink = ({
  children,
  isCurrentPage,
  href
}: BreadcrumbLinkProps) => (
  <Text as="li" variant="sm" weight={isCurrentPage ? 'semibold' : 'regular'}>
    <Link css={{ color: '$textMuted' }} to={href}>
      {children}
    </Link>
  </Text>
);
